import { Button } from '@/view/components/ui/button'
import { ChevronLeft } from 'lucide-react'

import { useGetLessonById } from '@/app/hooks/useGetLessonById'
import { Spinner } from '@/view/components/ui/spinner'
import { toast } from '@/view/components/ui/use-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { LessonForm } from './components/LessonForm'

export const LessonDetails = () => {
  const navigate = useNavigate()
  const { trainingId, lessonId } = useParams<{
    trainingId: string
    lessonId: string
  }>()

  const isNew = lessonId === 'new'

  const { data, isLoading, isError } = useGetLessonById({
    lessonId: lessonId!,
    enabled: !isNew,
  })

  const { lesson } = data ?? {}

  const handleBack = () => {
    if (!trainingId) {
      toast({
        title: 'Erro ao voltar',
        description: 'Treinamento não encontrado',
      })
      return
    }
    navigate(`/conteudos/gerenciar/treinamentos/${trainingId}`)
  }

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    )
  }

  if (isError) {
    return <div>Erro ao buscar aula</div>
  }

  if (!lesson && !isNew) {
    return <div>Aula não encontrada</div>
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          className="rounded-full"
          onClick={handleBack}
        >
          <ChevronLeft size={24} className="mr-2" />
        </Button>
        <h1 className="text-2xl font-semibold">
          {isNew ? 'Nova aula' : lesson?.name}
        </h1>
      </div>
      <LessonForm
        lesson={isNew ? undefined : lesson}
        trainingId={trainingId!}
      />
    </>
  )
}
